var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _ConsultationPlannedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import Store from "@ember-data/store";
import { service } from "@ember/service";
import JournalEvent from "core/models/abstract/planified-journal-event";
import Patient from "core/models/patient";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import TreatmentHistoryChangedJournalEvent from "./treatment-history-changed-journal-event";

//---- Automatically generated, don't update this part ----
/**
 * Represents the planification of a consultation.
 * The date of the consultation is set in occurredAt, even if it's in the future.
 */
let ConsultationPlannedJournalEvent = (_dec = attr(), _dec2 = attr(), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("number"), _dec6 = belongsTo("patient", {
  async: false,
  inverse: "consultationPlannedJournalEvents"
}), _dec7 = belongsTo("treatment-history-changed-journal-event", {
  async: false,
  inverse: "consultationPlannedJournalEvents"
}), _class = (_ConsultationPlannedJournalEvent = class ConsultationPlannedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * An OMOP provider.
     * The fields specialty-source-concept should be set to SPE (the only concept currently supported),
     * and specialty-source-value is a number representing the specialty.
     * @see provider.yml for more documentation.
     */
    _initializerDefineProperty(this, "provider", _descriptor, this);
    /**
     * An OMOP procedure.
     * The field procedure-source-concept should be set to SEMEIA as it comes from our software.
     * @see procedure-occurence.yml for more documentation.
     */
    _initializerDefineProperty(this, "procedure", _descriptor2, this);
    /**
     * The uuid of the corresponding treatment when consultation generated from a treatment history journal event.
     */
    _initializerDefineProperty(this, "originConsultationIdentifier", _descriptor3, this);
    /**
     * The type of the responsible. Could be null.
     */
    _initializerDefineProperty(this, "responsibleType", _descriptor4, this);
    /**
     * The id of the responsible, could be null
     */
    _initializerDefineProperty(this, "responsibleId", _descriptor5, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "store", _descriptor6, this);
    _initializerDefineProperty(this, "patient", _descriptor7, this);
    _initializerDefineProperty(this, "treatmentHistoryChangedJournalEvent", _descriptor8, this);
  }
  static validations(intl) {
    return {
      procedure: validatePresence({
        presence: true,
        description: intl.t("validations.consultation-planned-journal-event.procedure")
      }),
      provider: validatePresence({
        presence: true,
        description: intl.t("validations.consultation-planned-journal-event.provider")
      }),
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.consultation-planned-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
        onOrBefore: dayjs().add(50, "years").toDate()
      })],
      responsibleId: validateNumber({
        allowBlank: true,
        integer: true,
        description: intl.t("validations.consultation-planned-journal-event.responsible-id")
      }),
      responsibleType: validateInclusion({
        list: ["medic", "patient"],
        allowBlank: true,
        description: intl.t("validations.consultation-planned-journal-event.responsible-type")
      })
    };
  }
  get label() {
    return this.procedure.sourceLabel;
  }
  get responsibleFullName() {
    return this.store.peekRecord(this.responsibleType, this.responsibleId)?.fullName;
  }
}, _defineProperty(_ConsultationPlannedJournalEvent, "type", "consultation-planned-journal-event"), _ConsultationPlannedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "provider", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "procedure", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "originConsultationIdentifier", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "responsibleType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "responsibleId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "treatmentHistoryChangedJournalEvent", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConsultationPlannedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.